<app-breadcrumb [title]="'Преглед'" [items]="['Каса']" [active_item]="'Преглед'"></app-breadcrumb>
<ng-container *ngIf="isLoaded">
  <div style="display: flex; justify-content: end;">
    <button *ngIf="!currentKasa" type="button" style="margin-right: 10px;" class="btn btn-primary" (click)="onKasaOpen()"><i class="bi bi-check-circle"></i> Отвори Каса</button>
    <button *ngIf="currentKasa" type="button" style="margin-right: 10px;" class="btn btn-warning" (click)="onKasaClose()"><i class="bi bi-exclamation-triangle"></i> Затваряне Каса</button>
  </div>
  <table class="table table-hover">
    <thead>
      <tr>
        <th scope="col">Номер</th>
        <th scope="col">Начално Салдо</th>
        <th scope="col">Отварянане Каса</th>
        <th scope="col">Текуща Сума</th>
        <th scope="col">Крайно Салдо</th>
        <th scope="col">Затваряне</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let service of services" [ngClass]="!isSelected(service)?'':'selected-cell'" (click)="onSelected(service)">
        <td>{{service.idKasa}}</td>
        <td>{{service.startAmount}}</td>
        <td>{{getDate(service.createdOn)}}</td>
        <td>{{service.amount}}</td>
        <td>{{service.closeAmount}}</td>
        <td>{{getDate(service.closedOn)}}</td>
          </tr>

    </tbody>
  </table>
</ng-container>
<ng-container *ngIf="!isLoaded">
<div style="text-align: center;">
  <div class="spinner-grow spinner-grow-sm" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 30px; height: 30px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 40px; height: 40px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>

  <div class="spinner-grow" style="width: 50px; height: 50px;" role="status">
    <span class="visually-hidden">Loading...</span>
  </div>
</div>
</ng-container>
